import React from 'react';
import { motion } from 'framer-motion';

const ServiceNowConsultingServices = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="lg:py-[60px] py-[50px] bg-[#F1F1F1]">
            <div className="w-full max-w-[1440px] mx-auto lg:px-[80px] px-[40px]">
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-[67px]">

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        variants={fadeUpVariant}
                        className="w-full md:flex-1 flex justify-center"
                    >
                        <img
                            src="/assets/leverage/img2.png"
                            alt="ServiceNow Spiral Abstract"
                            className="w-full max-w-[529px] h-auto object-cover block"
                        />
                    </motion.div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        variants={fadeUpVariant}
                        className="w-full md:flex-1 text-[#01386A]"
                    >
                        <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] mb-5 tracking-tight">
                            ServiceNow<br />Consulting Services
                        </h2>

                        <p className="text-[14px] lg:text-[16px] font-[500] font-graphik leading-relaxed text-[#49577A] mb-6">
                            Accelerate digital transformation and streamline IT operations with our expert ServiceNow implementation and strategy solutions.
                        </p>

                        <div className="flex items-center cursor-pointer group w-fit">
                            <span className="font-graphik text-[14px] md:text-[16px] font-[500] text-[#01386A] border-b border-[#01386A] pb-[2px]">
                                Contact Now
                            </span>
                            <span className="text-[#ED6800] ml-2 font-bold text-[16px] transition-transform duration-300 group-hover:translate-x-1">&gt;</span>
                        </div>
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default ServiceNowConsultingServices;